/* ==========================================================================
   FNDRY — Selected products
   Plain JS, no framework. Tabs, rail scroll indicator, hover image zones,
   quick add to cart.
   ========================================================================== */

(function () {
  'use strict';

  var ROOT = '[data-fndry-sp]';
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');

  /* ---------- helpers -------------------------------------------------- */

  function $(sel, ctx) {
    return (ctx || document).querySelector(sel);
  }

  function $$(sel, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  }

  function railGap(rail) {
    var gap = parseFloat(window.getComputedStyle(rail).columnGap);
    return isNaN(gap) ? 0 : gap;
  }

  /* ---------- scroll indicator ----------------------------------------- */

  function measure(panel) {
    var rail = $('[data-fndry-sp-rail]', panel);
    var track = $('[data-fndry-sp-scroll]', panel);
    var thumb = $('[data-fndry-sp-thumb]', panel);
    if (!rail || !track || !thumb) return;

    var cards = $$('[data-fndry-sp-card]', rail);
    var overflow = rail.scrollWidth - rail.clientWidth;

    if (cards.length === 0 || overflow < 2) {
      track.hidden = true;
      return;
    }
    track.hidden = false;

    var stride = cards[0].offsetWidth + railGap(rail);
    var visible = Math.max(1, Math.round(rail.clientWidth / stride));
    var pages = Math.max(1, Math.ceil(cards.length / visible));

    thumb.style.width = 100 / pages + '%';
    panel._fndrySp = { rail: rail, thumb: thumb, track: track };
    position(panel);
  }

  function position(panel) {
    var state = panel._fndrySp;
    if (!state || state.track.hidden) return;

    var rail = state.rail;
    var max = rail.scrollWidth - rail.clientWidth;
    var ratio = max > 0 ? rail.scrollLeft / max : 0;
    var travel = state.track.clientWidth - state.thumb.clientWidth;

    state.thumb.style.transform = 'translateX(' + ratio * travel + 'px)';
  }

  function bindRail(panel) {
    var rail = $('[data-fndry-sp-rail]', panel);
    if (!rail) return;

    var ticking = false;
    rail.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          position(panel);
          ticking = false;
        });
      },
      { passive: true }
    );
  }

  /* ---------- hover image zones ---------------------------------------- */

  function bindZones(root) {
    $$('[data-fndry-sp-media]', root).forEach(function (media) {
      var layers = $$('[data-fndry-sp-layer]', media);
      if (layers.length < 2) return;

      function show(index) {
        layers.forEach(function (layer, i) {
          layer.classList.toggle('is-active', i === index);
        });
      }

      media.addEventListener('pointermove', function (event) {
        if (!canHover.matches) return;
        var rect = media.getBoundingClientRect();
        if (rect.width === 0) return;
        var pos = (event.clientX - rect.left) / rect.width;
        var zone = Math.floor(pos * layers.length);
        show(Math.min(layers.length - 1, Math.max(0, zone)));
      });

      media.addEventListener('pointerleave', function () {
        show(0);
      });

      // keyboard users get the primary image, never a stuck secondary
      media.addEventListener('focus', function () {
        show(0);
      });
    });
  }

  /* ---------- tabs ------------------------------------------------------ */

  function activate(root, blockId, focusTab) {
    var tabs = $$('[data-fndry-sp-tab]', root);
    var panels = $$('[data-fndry-sp-panel]', root);

    tabs.forEach(function (tab) {
      var on = tab.dataset.blockId === blockId;
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
      tab.tabIndex = on ? 0 : -1;
      if (on && focusTab) tab.focus();
    });

    panels.forEach(function (panel) {
      var on = panel.dataset.blockId === blockId;
      panel.hidden = !on;
      if (on) measure(panel);
    });
  }

  function bindTabs(root) {
    var tabs = $$('[data-fndry-sp-tab]', root);
    if (tabs.length === 0) return;

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        activate(root, tab.dataset.blockId, false);
      });

      tab.addEventListener('keydown', function (event) {
        var next = null;
        if (event.key === 'ArrowRight') next = tabs[(index + 1) % tabs.length];
        if (event.key === 'ArrowLeft') next = tabs[(index - 1 + tabs.length) % tabs.length];
        if (event.key === 'Home') next = tabs[0];
        if (event.key === 'End') next = tabs[tabs.length - 1];
        if (!next) return;
        event.preventDefault();
        activate(root, next.dataset.blockId, true);
      });
    });
  }

  /* ---------- add to cart ----------------------------------------------- */
  /* The added state is derived from the cart, not from the click. So it
     survives a reload, and it clears itself the moment the line item is
     removed anywhere on the site. */

  function cartRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function setAdded(button, on) {
    button.classList.toggle('is-added', on);
    button.disabled = on;
    var label = on ? button.dataset.addedLabel : button.dataset.addLabel;
    if (label && button.hasAttribute('aria-label')) button.setAttribute('aria-label', label);
  }

  function applyCart(cart) {
    var inCart = {};
    (cart && cart.items ? cart.items : []).forEach(function (item) {
      inCart[item.variant_id] = true;
    });

    $$('[data-fndry-sp-atc]').forEach(function (button) {
      setAdded(button, inCart[parseInt(button.dataset.variantId, 10)] === true);
    });
  }

  var cartRequest = null;

  function refreshCart(force) {
    if (!cartRequest || force) {
      cartRequest = fetch(cartRoot() + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (response) {
          return response.json();
        })
        .catch(function () {
          return null;
        });
    }
    return cartRequest.then(function (cart) {
      if (cart) applyCart(cart);
      return cart;
    });
  }

  function bindCart(root) {
    var addUrl = root.dataset.cartAddUrl || '/cart/add';

    $$('[data-fndry-sp-atc]', root).forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        if (button.disabled || button.classList.contains('is-added')) return;

        var id = parseInt(button.dataset.variantId, 10);
        if (!id) return;

        button.setAttribute('aria-busy', 'true');

        fetch(addUrl + '.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/javascript'
          },
          body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
        })
          .then(function (response) {
            if (!response.ok) throw new Error('add-to-cart failed');
            return response.json();
          })
          .then(function () {
            return refreshCart(true);
          })
          .then(function (cart) {
            // the header / cart drawer listens for this
            document.dispatchEvent(
              new CustomEvent('fndry:cart:updated', {
                detail: { cart: cart, variantId: id, source: 'fndry-selected-products' }
              })
            );
          })
          .catch(function () {
            window.location.href = root.dataset.cartUrl || '/cart';
          })
          .finally(function () {
            button.removeAttribute('aria-busy');
          });
      });
    });
  }

  /* Anything else on the site that changes the cart should either dispatch
     fndry:cart:updated with a cart object, or fndry:cart:refresh with nothing. */

  document.addEventListener('fndry:cart:updated', function (event) {
    if (event.detail && event.detail.cart) {
      applyCart(event.detail.cart);
    } else {
      refreshCart(true);
    }
  });

  document.addEventListener('fndry:cart:refresh', function () {
    refreshCart(true);
  });

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) refreshCart(true);
  });

  /* ---------- init ------------------------------------------------------ */

  function init(root) {
    if (!root || root.dataset.fndrySpReady === 'true') return;
    root.dataset.fndrySpReady = 'true';

    bindTabs(root);
    bindZones(root);
    bindCart(root);
    refreshCart(false);

    $$('[data-fndry-sp-panel]', root).forEach(function (panel) {
      bindRail(panel);
      if (!panel.hidden) measure(panel);
    });

    if ('ResizeObserver' in window) {
      /* P15 2026-10-23: measured in the next frame, not inside the observer.
         Showing or hiding the scroll indicator changes this root's own
         height, and doing that inside the callback is what browsers report
         as "ResizeObserver loop completed with undelivered notifications". */
      var frame = 0;
      var observer = new ResizeObserver(function () {
        if (frame) return;
        frame = window.requestAnimationFrame(function () {
          frame = 0;
          $$('[data-fndry-sp-panel]', root).forEach(function (panel) {
            if (!panel.hidden) measure(panel);
          });
        });
      });
      observer.observe(root);
    } else {
      window.addEventListener('resize', function () {
        $$('[data-fndry-sp-panel]', root).forEach(function (panel) {
          if (!panel.hidden) measure(panel);
        });
      });
    }
  }

  function initAll(scope) {
    $$(ROOT, scope || document).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var root = event.target.closest(ROOT);
    var panel = event.target.closest('[data-fndry-sp-panel]');
    if (root && panel) activate(root, panel.dataset.blockId, false);
  });
})();